import {h, Fragment} from "preact"
import { useSort } from "@nosto/preact";
import { useState } from "preact/hooks";
import { sortOptions } from "../../config"

export default function SortInsideSidebar({ value, className, options, label }) {
    const [isActive, setIsActive] = useState(false);

    const { activeSort, setSort } = useSort(sortOptions)

    const activeSortName = sortOptions.find(opt => opt.id === activeSort)?.value.name;


    const handleSortChange = event => {
        setSort(event.target.getAttribute("value"))
    }

    return (
            <li class={`ns-sidebar-dropdown ${isActive ? "ns-active" : ""}`} aria-expanded="false" onClick={() => setIsActive(!isActive)}>
            <span
                class="ns-anchor ns-relative ns-w-100 ns-border-box ns-p-4 nosto-facet-title"
                data-nosto-element="facet"
                aria-label={`${isActive ? 'Collapse' : 'Expand' }`}
            >
                <span class="ns-color-black ns-facet-name">Sort by</span>
                {/* {selectedFiltersCount > 0 && (
                    <span class="ns-total-count ns-d-inline-block ns-text-align-center ns-font-3 ns-font-bold ns-color-white ns-background-primary ns-ml-1">
                        {selectedFiltersCount}
                    </span>
                )} */}
                <svg aria-label="Plus icon" class="icon icon--plus" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path stroke="currentColor" stroke-linecap="round" stroke-width="1.5" vector-effect="non-scaling-stroke" d="M12 6v12M6 12h12"></path>
                </svg>
            </span>
            <div class="ns-sidebar-submenu ns-d-none ns-p-4">
                <ul class="ns-list-unstyled ns-p-0 ns-m-0 filter-bubbles original-style" role="menu">
                {options.map(option => (
                    <li key={option.value}  class="filter-bubble ns-d-flex ns-justify-content-between ns-align-items-center ns-font-3 ns-sort-option" data-nosto-element="facet-setting" role="menuitem"><label value={option.value} onClick={e => handleSortChange(e)} class={`ns-checkbox-dropdown ns-d-flex ns-align-items-center ns-color-black ${activeSort == option.value ? ' ns-active ' : ' '}`}>{option.label}</label></li>
                ))}
                </ul>
            </div>
            </li>
    )
}
